<template>
    <div class="Layout">
        <layout-header></layout-header>
        <div class="contentBox">
            <slot name="content" ></slot>
        </div>
        <layout-footer></layout-footer>
    </div>
</template>

<script>
import LayoutHeader from './Header.vue';
import LayoutFooter from './Footer.vue';

export default {
    name:'Layout',
    components: {
        LayoutHeader,
        LayoutFooter
    },
    props:{},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {},
}
</script>
<style scoped>
.contentBox{
    min-height: calc(100vh - 100px - 320px);
    margin-top: 100px;
}
</style>